export const STRUCTURE_LEVELS = [
  {
    key: 'division',
    heading: 'Choose your Division',
    ctaDefault: 'Divisions',
    ctaHover: 'Select this division',
  },
  {
    key: 'branch',
    heading: 'Choose your branch',
    ctaDefault: 'Branchs',
    ctaHover: 'Select this branch',
  },
  {
    key: 'section',
    heading: 'Choose your section',
    ctaDefault: 'Sections',
    ctaHover: 'Select this section',
  },
];

export const MEMBERSHIP_LEVEL = {
  key: 'membership',
  heading: 'Choose your membership role',
  ctaDefault: 'Role',
  ctaHover: 'Select this role',
};

export function buildDivisionsByIdFromList(divisions) {
  const m = new Map();
  for (const d of divisions || []) {
    if (d?.id != null) m.set(Number(d.id), d);
  }
  return m;
}

/** Section leaf matches allowed id exactly or is under it in the org tree (e.g. Pilot on Battle Group → Fighter Squadron). */
export function sectionMatchesAllowedOrgDivision(sectionId, allowedOrgDivisionId, divisionsById) {
  const sid = Number(sectionId);
  const aid = Number(allowedOrgDivisionId);
  if (!Number.isFinite(sid) || sid < 1 || !Number.isFinite(aid) || aid < 1) return false;
  if (sid === aid) return true;
  let cur = divisionsById.get(sid);
  while (cur) {
    if (Number(cur.id) === aid) return true;
    cur = cur.parentId != null ? divisionsById.get(Number(cur.parentId)) : null;
  }
  return false;
}

export function isCatalogEntryAllowedForSection(entry, sectionId, divisionsById) {
  const sid = Number(sectionId);
  if (!Number.isFinite(sid) || sid < 1) return false;
  const allowed = entry?.allowedDivisionIds || [];
  if (!allowed.length) return true;
  return allowed.some((id) => sectionMatchesAllowedOrgDivision(sid, id, divisionsById));
}

export function filterMembershipCatalogForSection(catalog, sectionId, divisions) {
  const sid = Number(sectionId);
  if (!Number.isFinite(sid) || sid < 1) return [];
  const divisionsById =
    divisions instanceof Map ? divisions : buildDivisionsByIdFromList(divisions);
  return (catalog || []).filter((entry) =>
    isCatalogEntryAllowedForSection(entry, sid, divisionsById),
  );
}

export function sectionHasValidMembershipTitles(catalog, sectionId, divisions) {
  return filterMembershipCatalogForSection(catalog, sectionId, divisions).length > 0;
}

export const SECTION_WITHOUT_VALID_TITLES_MESSAGE =
  'No gameloops are currently available for this section. You will be able to update your selection once new gameloops are added.';

export const STRUCTURE_TAGS_MIN = 2;
export const STRUCTURE_TAGS_MAX = 5;

export const DEFAULT_ORG_STRUCTURE_LOAD_URL = '/api/user/onboarding/org-structure';

export function buildStructureChildrenIndex(divisions) {
  const byParent = new Map();
  for (const d of divisions) {
    const parentKey = d.parentId == null ? 'root' : String(d.parentId);
    if (!byParent.has(parentKey)) byParent.set(parentKey, []);
    byParent.get(parentKey).push(d);
  }
  return byParent;
}

export function getStructureChildrenOf(byParent, parentId) {
  const key = parentId == null ? 'root' : String(parentId);
  return byParent.get(key) || [];
}

export function pickStructureBackgroundHlsUrl(byId, selected) {
  if (!byId || !selected) return null;
  const ids = [];
  if (selected.sectionId != null) ids.push(selected.sectionId);
  if (selected.branchId != null) ids.push(selected.branchId);
  if (selected.divisionId != null) ids.push(selected.divisionId);
  for (const id of ids) {
    const row = byId.get(id);
    const u =
      row && typeof row.backgroundHlsUrl === 'string' ? row.backgroundHlsUrl.trim() : '';
    if (u) return u;
  }
  return null;
}
